// Bumped on every deploy so a glance at the bottom-right corner tells you
// whether the browser is showing the build you just shipped or a cached one.
export const APP_VERSION = 'v70';
